import { createCommand } from '@commander-js/extra-typings';
import type { CommandServices } from '@wix/cli-command-contract';
import { Option } from 'commander';
import { createI18nT } from '../i18n.js';

export const devCommand = (services: CommandServices, cliVersion: string) => {
  const t = createI18nT();

  return createCommand('dev')
    .option('-s, --https', t('site_dev_command_def.option.https'))
    .addOption(
      new Option('--tunnel', t('site_dev_command_def.option.tunnel'))
        .conflicts('https')
        .hideHelp(true)
    )
    .description(t('site_dev_command_def.description'))
    .action(async (options, command) => {
      const { runCommand } = await import('./run-command.js');
      const { dev } = await import('../dev/index.js');

      await runCommand(command, services, cliVersion, (model) =>
        dev(model, services, options)
      );
    });
};
